// @ts-nocheck
// fetch all freelance users
export const FETCH_ALL_FREELANCE_REQUEST = "FETCH_ALL_FREELANCE_REQUEST";
export const FETCH_ALL_FREELANCE_SUCCESS = "FETCH_ALL_FREELANCE_SUCCESS";
export const FETCH_ALL_FREELANCE_FAILURE = "FETCH_ALL_FREELANCE_FAILURE";

// update a freelance user
export const UPDATE_FREELANCE_REQUEST = "UPDATE_FREELANCE_REQUEST";
export const UPDATE_FREELANCE_SUCCESS = "UPDATE_FREELANCE_SUCCESS";
export const UPDATE_FREELANCE_FAILURE = "UPDATE_FREELANCE_FAILURE";

// create a freelance user
export const CREATE_FREELANCE_REQUEST = "CREATE_FREELANCE_REQUEST";
export const CREATE_FREELANCE_SUCCESS = "CREATE_FREELANCE_SUCCESS";
export const CREATE_FREELANCE_FAILURE = "CREATE_FREELANCE_FAILURE";

// delete a freelance user
export const DELETE_FREELANCE_REQUEST = "DELETE_FREELANCE_REQUEST";
export const DELETE_FREELANCE_SUCCESS = "DELETE_FREELANCE_SUCCESS";
export const DELETE_FREELANCE_FAILURE = "DELETE_FREELANCE_FAILURE";